// extracted by mini-css-extract-plugin
module.exports = {"hidden":"kickedPage_hidden__2RUMB","visible":"kickedPage_visible__2yVh5","block":"kickedPage_block__3XoDp"};